import cn from 'classnames'
import React, { useEffect, useRef } from 'react'

import * as s from './Scalable.module.scss'

interface IScalableProps {
  children: React.ReactNode
  minHeight?: number
  maxHeight?: number
  minWidth?: number
  maxWidth?: number
}

const Scalable: React.FC<IScalableProps> = ({
  children,
  minHeight,
  maxHeight,
  minWidth,
  maxWidth,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const childRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = containerRef.current
    const child = childRef.current

    const resizeObserver = new ResizeObserver(() => {
      if (child && container) {
        child.style.transform = `scale(${1})`
        container.style.height = `${child.scrollHeight * 1}px`
      }

      if (container && child) {
        const containerWidth = container.offsetWidth
        const childWidth = child.scrollWidth
        const containerHeight = container.offsetHeight
        const childHeight = child.scrollHeight
        if (childWidth > 0) {
          const scaleX = containerWidth / childWidth
          const scaleY = containerHeight / childHeight
          const scale = Math.min(scaleX, scaleY)
          container.style.height = `${child.scrollHeight * scale}px`
          child.style.transform = `scale(${scale})`
        }
      }
    })

    if (child && container) {
      resizeObserver.observe(child)
      resizeObserver.observe(container)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return (
    <div className={cn(s.root)} ref={containerRef} style={{ minHeight, maxHeight }}>
      <div className={s.container} ref={childRef} style={{ minWidth, maxWidth }}>
        {children}
      </div>
    </div>
  )
}

export default Scalable
